import Alert from './alert';
import $ from 'jquery';

export default {
  form: null,

  bind: function() {
    this.form = $('#other-date');

    this.form.on('submit', this.search);
  },

  search: function(e) {
    e.preventDefault();

    var datePattern = /(\d{4})\-(\d{1,2})\-(\d{1,2})/;
    var value = $('#date-field').val();

    if (value.match(datePattern)) {
      window.location.href = '/bids/' + value;
    } else {
      Alert.show({ 'level': 'danger', 'message': 'Incorrect date format, please verify the date and try again.' });
    }
  }
};



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/other_date.js